import { ProviderOfficeStatus } from '../enums/provider-office-status.enum';
import { keyBy } from 'lodash-es';

export class ProviderOfficeStatusOption {
  constructor(public value: string, public display: string, public deprecated: boolean = false) {}
}

const providerOfficeStatusOptions = [
  new ProviderOfficeStatusOption(ProviderOfficeStatus.validFax, "Valid Fax"),
  new ProviderOfficeStatusOption(ProviderOfficeStatus.verified, "Verified"),
  new ProviderOfficeStatusOption(ProviderOfficeStatus.unresponsiveOffice, "Unresponsive Office"),
  new ProviderOfficeStatusOption(ProviderOfficeStatus.unresponsiveProvider, "Unresponsive Provider"),
  new ProviderOfficeStatusOption(ProviderOfficeStatus.testing, "Testing"),
  new ProviderOfficeStatusOption(ProviderOfficeStatus.faxFailed, "Fax Failed - Nonfunctional"),
  new ProviderOfficeStatusOption(ProviderOfficeStatus.providerNoLongerAtOffice, "Provider No Longer at Office"),
  new ProviderOfficeStatusOption(ProviderOfficeStatus.officeOptedOut, "Office Opted Out"),
  new ProviderOfficeStatusOption(ProviderOfficeStatus.notAMedicalOffice, "Not a Medical Office"),
  new ProviderOfficeStatusOption(ProviderOfficeStatus.providerNotAtOffice, "Provider Not at Office"),
];

const keyedStatusOptions = keyBy(providerOfficeStatusOptions, 'value');

const providerOfficeShortCodes = {
  [ProviderOfficeStatus.verified]: 'V',
  [ProviderOfficeStatus.validFax]: 'VF',
  [ProviderOfficeStatus.unresponsiveOffice]: 'UO',
  [ProviderOfficeStatus.unresponsiveProvider]: 'UP',
  [ProviderOfficeStatus.faxFailed]: 'FFN',
  [ProviderOfficeStatus.testing]: 'T',
  [ProviderOfficeStatus.providerNoLongerAtOffice]: 'PNLO',
  [ProviderOfficeStatus.officeOptedOut]: 'OOO',
  [ProviderOfficeStatus.notAMedicalOffice]: 'NMO',
  [ProviderOfficeStatus.providerNotAtOffice]: 'PNO',
};

const displayProviderOfficeFaxStatus = (value: string): string => {
  return providerOfficeShortCodes[value] || 'NA';
}

const filterProviderStatusOptions = (providerOfficeStatus: string) =>
  providerOfficeStatusOptions.filter(statusOption =>
    !statusOption.deprecated || statusOption.value === providerOfficeStatus)

export {
  keyedStatusOptions,
  providerOfficeStatusOptions,
  providerOfficeShortCodes,
  displayProviderOfficeFaxStatus,
  filterProviderStatusOptions,
};
